import React from "react";
import cx from "classnames";
export const EditorMentionMenuItem = ({ active, children, ...rest }) => {
    return (React.createElement("div", { className: cx("editor-mention-menu-item", {
            "editor-mention-menu-item--active": active,
        }), ...rest }, children));
};
